import { Review, ReviewCreateUpdate } from "@/types/reviewType";
import { Axios } from "@/utils/axios";

export const getSangjoReviewDetail = async (id: string) => {
  const { data } = await Axios.get<Review>(`/sangjo_reviews/${id}/`);
  return data;
};

export const getSangjoReview = async (id: string, orderby: string) => {
  const { data } = await Axios.get(`/sangjos/${id}/reviews?order_by=${orderby}`);
  return data;
};

export const postSangjoReview = async (body: ReviewCreateUpdate) => {
  const response = await Axios.post(`/sangjo_reviews/`, body);
  return response;
};

export const putSangjoReview = async ({ id, body }: { id?: number; body: ReviewCreateUpdate }) => {
  const response = await Axios.put(`/sangjo_reviews/${id}/`, body);
  return response;
};

export const deleteSangjoReview = (id: number) => {
  return Axios.delete(`/sangjo_reviews/${id}/`);
};

// 분리
export const getSangjoFuneralDirector = async (id: string) => {
  const { data } = await Axios.get(`/sangjos/${id}/funeral_directors/`);
  return data;
};
